import { render } from "./prospectkaban.vue?vue&type=template&id=4383ac87"
import script from "./prospectkaban.vue?vue&type=script&lang=js"
export * from "./prospectkaban.vue?vue&type=script&lang=js"

import "./prospectkaban.vue?vue&type=style&index=0&id=4383ac87&lang=css"

import exportComponent from "C:\\Users\\Luis\\Documents\\Anfisbena\\Projects\\crm\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__